import { render, staticRenderFns } from "./AppGameControl.vue?vue&type=template&id=15b33c5b&scoped=true&"
import script from "./AppGameControl.vue?vue&type=script&lang=js&"
export * from "./AppGameControl.vue?vue&type=script&lang=js&"
import style0 from "./AppGameControl.vue?vue&type=style&index=0&id=15b33c5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b33c5b",
  null
  
)

export default component.exports